import React from "react";
import "../../Product/Scheduling/scheduling.css";

export function SkeletonRow({ cols = 4 }) {
  return (
    <div className="sched-skel-row">
      {Array.from({ length: cols }).map((_, i) => (
        <div key={i} className="sched-skel" />
      ))}
    </div>
  );
}
